/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
type GrapefulClub_viewer$ref = any;
export type GrapefulClub_QueryVariables = {};
export type GrapefulClub_QueryResponse = {
    readonly viewer: ({
        readonly id: string | null;
        readonly " $fragmentRefs": GrapefulClub_viewer$ref;
    }) | null;
};
export type GrapefulClub_Query = {
    readonly response: GrapefulClub_QueryResponse;
    readonly variables: GrapefulClub_QueryVariables;
};



/*
query GrapefulClub_Query {
  viewer {
    id
    ...GrapefulClub_viewer
  }
}

fragment GrapefulClub_viewer on Viewer {
  id
  ...GrapefulClubFlow_viewer
  user {
    id
    conciergeUser {
      permissions {
        id
        oneCommerce {
          id
          preferredCustomer {
            access
          }
          ceo {
            access
          }
        }
      }
      id
    }
    permissions {
      id
      oneCommerce {
        id
        preferredCustomer {
          access
        }
        ceo {
          access
        }
      }
    }
  }
}

fragment GrapefulClubFlow_viewer on Viewer {
  ...ChooseCharityStep_viewer
  ...WineClubStep_viewer
  ...RecapStep_viewer
}

fragment ChooseCharityStep_viewer on Viewer {
  user {
    id
    firstName
    cart {
      id
      preferredCustomerDraft {
        nonProfitId
        id
      }
    }
    conciergeUser {
      id
      firstName
    }
  }
  nonProfits(first: 1000, status: "preApproved", donationType: "preferredCustomer") {
    edges {
      node {
        id
        nonProfitId
        nonProfitName
        nonProfitDescription
      }
    }
  }
}

fragment WineClubStep_viewer on Viewer {
  user {
    id
    firstName
    cart {
      id
      preferredCustomerDraft {
        wineClub
        id
      }
    }
    conciergeUser {
      id
      firstName
    }
  }
  wineClub(first: 1000) {
    id
    date {
      quarter
    }
    fullPrice
    price
    image
    mariBotDescription
    products {
      edges {
        node {
          id
          productId
          name
          price
        }
      }
    }
  }
}

fragment RecapStep_viewer on Viewer {
  productsBulk(productIds: ["784f3fe8-b3d7-496a-bb23-78e6fe9d0b6e", "e59cd67d-084f-48c4-b51f-3d20750e793f"]) {
    edges {
      node {
        id
        productId
        name
        price
      }
    }
  }
  nonProfits(first: 1000, status: "preApproved", donationType: "preferredCustomer") {
    edges {
      node {
        id
        nonProfitId
        nonProfitName
      }
    }
  }
  user {
    id
    firstName
    cart {
      id
      totalNumberOfItems
      preferredCustomerDraft {
        nonProfitId
        wineClub
        id
      }
      entries(first: 1000) {
        edges {
          node {
            id
            product {
              id
              productId
            }
            quantity
          }
        }
      }
    }
    conciergeUser {
      id
      firstName
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
    } as any), v1 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "firstName",
        "args": null,
        "storageKey": null
    } as any), v2 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "nonProfitId",
        "args": null,
        "storageKey": null
    } as any), v3 = ({
        "kind": "Literal",
        "name": "first",
        "value": 1000,
        "type": "Int"
    } as any), v4 = [
        (v3 /*: any*/)
    ], v5 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "productId",
        "args": null,
        "storageKey": null
    } as any), v6 = [
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "access",
            "args": null,
            "storageKey": null
        } as any)
    ], v7 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "permissions",
        "storageKey": null,
        "args": null,
        "concreteType": "PermissionsType",
        "plural": false,
        "selections": [
            (v0 /*: any*/),
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "oneCommerce",
                "storageKey": null,
                "args": null,
                "concreteType": "OneCommerceType",
                "plural": false,
                "selections": [
                    (v0 /*: any*/),
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "preferredCustomer",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "AccessType",
                        "plural": false,
                        "selections": (v6 /*: any*/)
                    },
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "ceo",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "AccessType",
                        "plural": false,
                        "selections": (v6 /*: any*/)
                    }
                ]
            }
        ]
    } as any), v8 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "price",
        "args": null,
        "storageKey": null
    } as any), v9 = [
        (v0 /*: any*/),
        (v5 /*: any*/),
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "name",
            "args": null,
            "storageKey": null
        } as any),
        (v8 /*: any*/)
    ];
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "GrapefulClub_Query",
            "type": "Root",
            "metadata": null,
            "argumentDefinitions": [],
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        (v0 /*: any*/),
                        {
                            "kind": "FragmentSpread",
                            "name": "GrapefulClub_viewer",
                            "args": null
                        }
                    ]
                }
            ]
        },
        "operation": {
            "kind": "Operation",
            "name": "GrapefulClub_Query",
            "argumentDefinitions": [],
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        (v0 /*: any*/),
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "user",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "User",
                            "plural": false,
                            "selections": [
                                (v0 /*: any*/),
                                (v1 /*: any*/),
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "cart",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "Cart",
                                    "plural": false,
                                    "selections": [
                                        (v0 /*: any*/),
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "preferredCustomerDraft",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "PreferredCustomerDraft",
                                            "plural": false,
                                            "selections": [
                                                (v2 /*: any*/),
                                                (v0 /*: any*/),
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "wineClub",
                                                    "args": null,
                                                    "storageKey": null
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "totalNumberOfItems",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "entries",
                                            "storageKey": "entries(first:1000)",
                                            "args": (v4 /*: any*/),
                                            "concreteType": "CartEntryV3Connection",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "edges",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "CartEntryV3Edge",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "node",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "CartEntryV3",
                                                            "plural": false,
                                                            "selections": [
                                                                (v0 /*: any*/),
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "alias": null,
                                                                    "name": "product",
                                                                    "storageKey": null,
                                                                    "args": null,
                                                                    "concreteType": "Product",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v0 /*: any*/),
                                                                        (v5 /*: any*/)
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "quantity",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "conciergeUser",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "User",
                                    "plural": false,
                                    "selections": [
                                        (v0 /*: any*/),
                                        (v1 /*: any*/),
                                        (v7 /*: any*/)
                                    ]
                                },
                                (v7 /*: any*/)
                            ]
                        },
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "nonProfits",
                            "storageKey": "nonProfits(donationType:\"preferredCustomer\",first:1000,status:\"preApproved\")",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "donationType",
                                    "value": "preferredCustomer",
                                    "type": "String"
                                },
                                (v3 /*: any*/),
                                {
                                    "kind": "Literal",
                                    "name": "status",
                                    "value": "preApproved",
                                    "type": "String"
                                }
                            ],
                            "concreteType": "NonProfitConnection",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "edges",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "NonProfitEdge",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "node",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "NonProfit",
                                            "plural": false,
                                            "selections": [
                                                (v0 /*: any*/),
                                                (v2 /*: any*/),
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "nonProfitName",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "nonProfitDescription",
                                                    "args": null,
                                                    "storageKey": null
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "wineClub",
                            "storageKey": "wineClub(first:1000)",
                            "args": (v4 /*: any*/),
                            "concreteType": "WineClub",
                            "plural": false,
                            "selections": [
                                (v0 /*: any*/),
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "date",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "WineClubDate",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "quarter",
                                            "args": null,
                                            "storageKey": null
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "fullPrice",
                                    "args": null,
                                    "storageKey": null
                                },
                                (v8 /*: any*/),
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "image",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "mariBotDescription",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "products",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "WineClubProductConnection",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "edges",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "WineClubProductEdge",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "node",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "WineClubProductType",
                                                    "plural": false,
                                                    "selections": (v9 /*: any*/)
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "productsBulk",
                            "storageKey": "productsBulk(productIds:[\"784f3fe8-b3d7-496a-bb23-78e6fe9d0b6e\",\"e59cd67d-084f-48c4-b51f-3d20750e793f\"])",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "productIds",
                                    "value": [
                                        "784f3fe8-b3d7-496a-bb23-78e6fe9d0b6e",
                                        "e59cd67d-084f-48c4-b51f-3d20750e793f"
                                    ],
                                    "type": "[String]"
                                }
                            ],
                            "concreteType": "ProductConnection",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "edges",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "ProductEdge",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "node",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "Product",
                                            "plural": false,
                                            "selections": (v9 /*: any*/)
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "operationKind": "query",
            "name": "GrapefulClub_Query",
            "id": null,
            "text": "query GrapefulClub_Query {\n  viewer {\n    id\n    ...GrapefulClub_viewer\n  }\n}\n\nfragment GrapefulClub_viewer on Viewer {\n  id\n  ...GrapefulClubFlow_viewer\n  user {\n    id\n    conciergeUser {\n      permissions {\n        id\n        oneCommerce {\n          id\n          preferredCustomer {\n            access\n          }\n          ceo {\n            access\n          }\n        }\n      }\n      id\n    }\n    permissions {\n      id\n      oneCommerce {\n        id\n        preferredCustomer {\n          access\n        }\n        ceo {\n          access\n        }\n      }\n    }\n  }\n}\n\nfragment GrapefulClubFlow_viewer on Viewer {\n  ...ChooseCharityStep_viewer\n  ...WineClubStep_viewer\n  ...RecapStep_viewer\n}\n\nfragment ChooseCharityStep_viewer on Viewer {\n  user {\n    id\n    firstName\n    cart {\n      id\n      preferredCustomerDraft {\n        nonProfitId\n        id\n      }\n    }\n    conciergeUser {\n      id\n      firstName\n    }\n  }\n  nonProfits(first: 1000, status: \"preApproved\", donationType: \"preferredCustomer\") {\n    edges {\n      node {\n        id\n        nonProfitId\n        nonProfitName\n        nonProfitDescription\n      }\n    }\n  }\n}\n\nfragment WineClubStep_viewer on Viewer {\n  user {\n    id\n    firstName\n    cart {\n      id\n      preferredCustomerDraft {\n        wineClub\n        id\n      }\n    }\n    conciergeUser {\n      id\n      firstName\n    }\n  }\n  wineClub(first: 1000) {\n    id\n    date {\n      quarter\n    }\n    fullPrice\n    price\n    image\n    mariBotDescription\n    products {\n      edges {\n        node {\n          id\n          productId\n          name\n          price\n        }\n      }\n    }\n  }\n}\n\nfragment RecapStep_viewer on Viewer {\n  productsBulk(productIds: [\"784f3fe8-b3d7-496a-bb23-78e6fe9d0b6e\", \"e59cd67d-084f-48c4-b51f-3d20750e793f\"]) {\n    edges {\n      node {\n        id\n        productId\n        name\n        price\n      }\n    }\n  }\n  nonProfits(first: 1000, status: \"preApproved\", donationType: \"preferredCustomer\") {\n    edges {\n      node {\n        id\n        nonProfitId\n        nonProfitName\n      }\n    }\n  }\n  user {\n    id\n    firstName\n    cart {\n      id\n      totalNumberOfItems\n      preferredCustomerDraft {\n        nonProfitId\n        wineClub\n        id\n      }\n      entries(first: 1000) {\n        edges {\n          node {\n            id\n            product {\n              id\n              productId\n            }\n            quantity\n          }\n        }\n      }\n    }\n    conciergeUser {\n      id\n      firstName\n    }\n  }\n}\n",
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = '2868ba2bd23e9594e2cffd6d599bb174';
export default node;
